'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _reactBootstrap = require('react-bootstrap');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPureRenderShallowEqual = require('react-pure-render/shallowEqual');

var _reactPureRenderShallowEqual2 = _interopRequireDefault(_reactPureRenderShallowEqual);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = {
	_$LoadingButton: {
		displayName: 'LoadingButton'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var LoadingButton = (function (_React$Component) {
	_inherits(LoadingButton, _React$Component);

	function LoadingButton() {
		_classCallCheck(this, _LoadingButton);

		_React$Component.apply(this, arguments);
	}

	LoadingButton.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {

		var shouldUpdate = !_reactPureRenderShallowEqual2['default'](this.props, nextProps) || !_reactPureRenderShallowEqual2['default'](this.state, nextState);

		return shouldUpdate;
	};

	LoadingButton.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			_reactBootstrap.Button,
			{ disabled: this.props.loading,
				type: 'submit',
				className: _classnames2['default']({ disabled: this.props.disabled }),
				bsStyle: this.props.bsStyle,
				onClick: function () {
					return _this.props.onClick();
				} },
			_react2['default'].createElement(
				'span',
				null,
				this.props.loading && _react2['default'].createElement('i', { className: 'fa fa-spinner rotate position-left' }),
				!this.props.loading && _react2['default'].createElement('i', { className: this.props.icon }),
				this.props.title
			)
		);
	};

	_createClass(LoadingButton, null, [{
		key: 'propTypes',
		value: {
			loading: _react2['default'].PropTypes.bool.isRequired,
			disabled: _react2['default'].PropTypes.bool,
			title: _react2['default'].PropTypes.string.isRequired,
			bsStyle: _react2['default'].PropTypes.string,
			icon: _react2['default'].PropTypes.string,
			onClick: _react2['default'].PropTypes.func.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			bsStyle: 'primary',
			icon: 'fa fa-check position-left',
			disabled: false
		},
		enumerable: true
	}]);

	var _LoadingButton = LoadingButton;
	LoadingButton = _wrapComponent('_$LoadingButton')(LoadingButton) || LoadingButton;
	return LoadingButton;
})(_react2['default'].Component);

exports['default'] = LoadingButton;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-loader/src/LoadingButton.js
 ** module id = 1047
 ** module chunks = 1
 **/